











import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'exam-intro',
})
export default class ExamIntro extends Vue { }
